@if (selfCheckoutForm && selfCheckoutForm.form) {
  <ng-container>
    <verify-form-page
      [page]="selfCheckoutForm.form"
      [pages]="[selfCheckoutForm.form]"
      [style]="selfCheckoutForm.style"
      [storeId]="[hash, 'confirm']"
      [disabledActions]="disabledActions"
      [validationStrategy]="validationStrategy"
      (action)="handleAction($event)"
    ></verify-form-page
  ></ng-container>
}

<next-raisenow-modal
  (finished)="_rnModalResult.next('success')"
  (closed)="_rnModalResult.next('cancel')"
></next-raisenow-modal>

<div
  class="loading-overlay"
  [class.loading-overlay--shown]="isUploading$ | ngrxPush"
>
  <fmnts-loading-indicator size="sm"></fmnts-loading-indicator>
</div>
